import { VImg } from 'vuetify/lib/components/VImg';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VImg,{attrs:{"width":`${_vm.width}px`,"src":_vm.src}})
}
var staticRenderFns = []

export { render, staticRenderFns }